import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

export module SiteSettingsStyles {
  export const DisabledLink: React.CSSProperties = {
    color: applyColor(DesignTokens.color.font.default.disabled, TabStyles.Typography.Color.Disabled),
  };

  export const WarningText = style({
    paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
    fontStyle: 'italic'
  });
}
